import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getBranchGroups = (params) => httpClient.get(`${ENDPOINT_API.BRANCH_GROUPS}`, { params });
const getBranchGroupAssign = (id, params) => httpClient.get(`${ENDPOINT_API.BRANCH_GROUPS}/${id}/branches`, { params });
const postBranchGroupAssign = (id, params) => httpClient.post(`${ENDPOINT_API.BRANCH_GROUPS}/${id}/assign`, params);

export {
	getBranchGroups,
	getBranchGroupAssign,
	postBranchGroupAssign,
};
